export default __webpack_public_path__ + "30a81ccb7641fb5e4ab88b1a0a5f69d3.svg";